import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { RadioList } from 'site-modules/shared/components/radio-list/radio-list';
import { RadioEntity } from 'site-modules/lease-deals/components/filters/entities/options-entity';
import { LEASE_DEALS_FILTERS } from 'site-modules/lease-deals/constants/lease-deals-constants';
import { EventToolbox } from 'client/utils/event-toolbox';
import { TrackingConstant } from 'client/tracking/constant';

import './sort-control.scss';

export const SortControl = ({ options, selectedValues = [], onChange }) => {
  const handleChange = useCallback(
    e => {
      EventToolbox.fireTrackAction({
        event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
        event_data: {
          action_name: TrackingConstant.ACTION_TOOL_SELECT,
          subaction_name: 'update_sort',
          action_category: TrackingConstant.USER_ACTION_CATEGORY,
          action_cause: TrackingConstant.ACTION_CAUSE_LINK_CLICK,
          creative_id: LEASE_DEALS_FILTERS,
          value: e.target?.value,
        },
      });
      onChange([e.target?.value]);
    },
    [onChange]
  );

  return (
    <RadioList
      list={options}
      name="Sort by"
      onChange={handleChange}
      checked={selectedValues[0]}
      labelContainerClassName="px-0 m-0 w-100"
      formGroupClassName="py-0_5 line-height-1_5 px-1_5"
      textClassName=""
      checkmarkClassName="size-24"
    />
  );
};

SortControl.propTypes = {
  onChange: PropTypes.func.isRequired,
  options: RadioEntity.isRequired,
  selectedValues: PropTypes.arrayOf(PropTypes.string),
};
